import { Component } from '@angular/core';
import { Data, ObservableData, DataLoaderService, ResetService, ProgressBarService,Subscription, PriceCalculationService, VehicleInfoService } from '../expert-service-call.index';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { SortingService } from '../expert-service-call.index'
import { Utils } from '../../../../shared/utils';

@Component({
	selector: 'expert-factory-options',
	templateUrl: './expert-factory-options.template.html',
	styleUrls: ['./expert-factory-options.component.css']
})
export class ExpertFactoryOptions {
	public factoryOptions: Data[];
	public flag: boolean = false;
	public factoryKeyValues: String[] = [];
	public expFactory: Data[] = [];
	public selected: Data[] = [];
	public standardSelected: Data[] = [];
	public retained: ObservableData[] = [];
	public subscription: Subscription;
	public subscriptionRemoved: Subscription;
	private temp: Data[] = [];
	public expertFactoryOptions: any;
	public icon: string = "gray";
	public noMatchFound: String;
	public vehicleInfo: any;

	constructor(private dataLoaderService: DataLoaderService, private sortingService: SortingService,
		private priceCalculationService: PriceCalculationService,private progressService: ProgressBarService, 
		private vehicleInfoService: VehicleInfoService,  private resetService: ResetService, private translateService: TranslateService) {
		this.factoryOptions = this.dataLoaderService.data.facOptions;
		this.vehicleInfo = this.vehicleInfoService.extractData();
	}

	ngOnInit() {
		if(this.factoryOptions.length == 0){
			this.dataLoaderService.flagDictionary.noFacOptions = true;
		}
		//Retention Service
		this.subscription = this.priceCalculationService.notifyObservableNormalComp$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "normalFactory") {
				let tempFac = [];
				if (selectedOption.data[0] != undefined) {
					this.selected = [];
					this.temp = [];
					
					for (let i = 0; i < selectedOption.data[0].length; i++) {

						this.selected.push(selectedOption.data[0][i].code);
						this.selected = _.uniqBy(this.selected, function (o) {
							return o;
						});
						this.temp.push(selectedOption.data[0][i]);
						// for undo
						tempFac.push(selectedOption.data[0][i].code);
						/* if (selectedOption.data[0][i].tempStdFlag) {
							this.standardSelected.push(selectedOption.data[0][i].code)
						}
						else {
							this.selected.push(selectedOption.data[0][i].code);
						}

						this.selected = _.uniqBy(this.selected, function (o) {
							return o;
						});
						this.standardSelected = _.uniqBy(this.standardSelected, function (o) {
							return o;
						});
						this.temp.push(selectedOption.data[0][i]); */
					}
					// for undo
					if(!this.dataLoaderService.flagDictionary.undoActivatedForFactory){
						this.dataLoaderService.previousFactoryExp= tempFac;
					}
				}
				else{
					this.selected = [];
					if(!this.dataLoaderService.flagDictionary.undoActivatedForFactory){
						tempFac=[];
						this.dataLoaderService.previousFactoryExp= [];
					}
				}
			}
		});

		// for undo alternative option
		
		this.priceCalculationService.notifyObservableExpertCompLastItem$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "expertFactory") {
				let tempFac = [];
				this.selected=[];
				this.temp = [];
				if (selectedOption.data[0] != undefined) {
					for (let i = 0; i < selectedOption.data[0].length; i++) {

						this.selected.push(selectedOption.data[0][i].code);
						this.selected = _.uniqBy(this.selected, function (o) {
							return o;
						});
						this.temp.push(selectedOption.data[0][i]);
						tempFac.push(selectedOption.data[0][i].code);
					}
					this.dataLoaderService.previousFactoryExp= tempFac;

				} else {
					this.selected = [];
					if(!this.dataLoaderService.flagDictionary.undoActivatedForFactory){
						tempFac=[];
						this.dataLoaderService.previousFactoryExp= [];
					}
				}
				
				this.dataLoaderService.flagDictionary.undoActivatedForFactory= false;
				this.dataLoaderService.flagDictionary.undoActivated= false;
				
				this.progressService.progressBarValidation();
				
			}
		});
		// Undo - End
		//On load				
		this.factoryOptions.forEach(element => {
			if (element.selected === true) {
				this.expFactory.unshift(element);
			}
		});
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.expFactory] });
		// this.priceCalculationService.expertModePriceCalculation();
		this.priceCalculationService.normalModePriceCalculation();


		//Reset Service
		this.subscription = this.resetService.notifyObservable$.subscribe((res) => {
			this.selected = this.resetService.expFactoryCodes;
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertFactory", data: [this.resetService.expFactory] });
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.resetService.expFactory] });
			this.priceCalculationService.expertModePriceCalculation();

		});
	}



	ngAfterContentChecked() {
		this.factoryKeyValues = [];
		for (let index = 0; index < this.factoryOptions.length; index++) {
			if (this.factoryOptions[index].selected === false) {
				this.factoryKeyValues.push(((this.factoryOptions[index].code + " - " + this.factoryOptions[index].description)));
			}

		}

		for (let j = 0; j < this.factoryKeyValues.length; j++) {
			for (let i = 0; i < this.selected.length; i++) {

				let item = this.factoryKeyValues[j].substring(0, this.factoryKeyValues[j].indexOf(' - '));
				let temp = this.selected[i] + "";
				if (item === temp) {

					this.factoryKeyValues.splice(Number(j), 1);
				}
			}
		}
	}
	clearOptions() {
		this.expertFactoryOptions = null;
	}

	// Set flags to activate undo 
	undoActivate(){
		// for undo operation in alternative screen -start 
		this.dataLoaderService.flagDictionary.undoActivatedForFactory= true;
		this.dataLoaderService.flagDictionary.undoActivated= true;
		// for undo operation in alternative screen -end
	}
	
	//adds selected factory color
	onFactoryOptionClick(item) {
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);
		
		this.undoActivate() //undo activate

		this.dataLoaderService.flagDictionary.closeFlag = false;
		let factoryCode;
		factoryCode = item.substr(0, 3);
		// this.dataLoaderService.expAdd.push(factoryCode);
		this.expFactory = this.temp;
		let count = 0;
		for (let i = 0; i < this.factoryOptions.length; i++) {
			if (this.factoryOptions[i].code == factoryCode) {
				for (let j = 0; j < this.selected.length; j++) {
					if (factoryCode != this.selected[j]) {
						count++;
					}
				}
				if (count == this.selected.length) {
					this.dataLoaderService.flagDictionary.expertValidateFlag = true;
					this.dataLoaderService.flagDictionary.expertvalidated = false;
					this.selected.push(factoryCode);
					this.expFactory.unshift(this.factoryOptions[i]);
					this.factoryOptions[i].selected = true;
				}
				else {
					this.factoryOptions[i].selected = false;
				}
			}
		}
		this.dataLoaderService.flagDictionary.migrationFlag = false;
		this.sortingService.sortCodes(this.factoryOptions,true)
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertFactory", data: [this.expFactory] });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.expFactory] });
		this.priceCalculationService.expertModePriceCalculation();
		
	}

	viewAll() {
		this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;
	}

	// removes the selected factory color	
	deleteSelExpFactoryOpt(item) {
		this.dataLoaderService.flagDictionary.closeFlag = false;
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);
		this.undoActivate();
		let factoryCode;
		factoryCode = item.substr(0, 3);
		this.expFactory = this.temp;
		this.priceCalculationService.notifyExpertCompForRemoved({ fromComponent: "expertFactory", data: [this.expFactory] });

		for (let i in this.selected) {
			if (this.selected[i] == factoryCode) {
				this.selected.splice(Number(i), 1);
			}
		}
		for (let j in this.expFactory) {
			if (this.expFactory[j].code === factoryCode) {
				// if (this.expFactory[j].selected) {
				// 	this.dataLoaderService.expertRemovedCodes.push(this.expFactory[j]);
				// }
				this.expFactory.splice(Number(j), 1);
				this.dataLoaderService.flagDictionary.expertValidateFlag = true;
				this.dataLoaderService.flagDictionary.expertvalidated = false;
			}
		}
		let selcFacForRem = [];
		for (let k in this.factoryOptions) {
			if (this.factoryOptions[k].selected) {
				selcFacForRem.push(this.factoryOptions[k]);
			}
		}
		this.priceCalculationService.notifyExpertCompForRemoved({ fromComponent: "expertFactory", data: [selcFacForRem] });
		for (let k in this.factoryOptions) {
			if (this.factoryOptions[k].code === factoryCode) {
				this.factoryOptions[k].selected = false;
			}
		}
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertFactory", data: [this.expFactory] });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.expFactory] });
		// this.priceCalculationService.expertModePriceCalculation();
		this.priceCalculationService.normalModePriceCalculation();
		

	}
	openviewMoreFac() {
		this.dataLoaderService.flagDictionary.viewMoreFlag = true;
		this.dataLoaderService.flagDictionary.factoryFlag = true;
		this.dataLoaderService.flagDictionary.localFlag = false;
		this.dataLoaderService.flagDictionary.packageFlag = false;
	}

	checkForEGFacOptions(){
		if(this.isMarketEG()){
			if(this.dataLoaderService.data.facOptions.length>0){
				return false;
			}
			else{
				return true;
			}
		}
	}

	isMarketEG(){
		return Utils.isCountryEG(this.vehicleInfo.orderingMarket);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-factory-options/expert-factory-options.component.ts